import { Button, Dialog, DialogActions, DialogContent } from "@mui/material";
import { Component } from "react";
import DialogTitleWithCloseButton from "../../../components/DialogTitleWithCloseButton";
import CustomerForm from "../../../components/CustomerForm";
import { EventEmitter } from "events";


export default class Editor extends Component {

   eventBus = new EventEmitter();

   submit = () => {
      this.eventBus.emit(CustomerForm.SUBMIT_EVENT, data => {
         if (!data)
            return;
         this.props.onClose(data);
      });
   }

   render() {
      return <Dialog open fullWidth maxWidth="sm">
         <DialogTitleWithCloseButton onClose={this.props.onClose}>
            Edit Customer
         </DialogTitleWithCloseButton>
         <DialogContent dividers>
            <CustomerForm
               customer={this.props.customer}
               eventBus={this.eventBus}
            />
         </DialogContent>
         <DialogActions>
            <Button onClick={this.submit} variant="contained">
               SAVE
            </Button>
         </DialogActions>
      </Dialog>
   }

}